const USAGE_LIMIT_REACHED_MESSAGE =
  'Spending limit reached. Adjust your spending limit in Settings > Billing to continue.';
const PAYMENT_REQUIRED_MESSAGE = 'Billing access required. Update your billing settings to continue.';

export function isUsageLimitReachedError(message: string | undefined): boolean {
  return message === 'USAGE_LIMIT_REACHED' || message?.includes('Usage limit reached') === true;
}

export function isPaymentRequiredError(message: string | undefined): boolean {
  return message === 'PAYMENT_REQUIRED';
}

export function getBillingGuardrailMessage(message: string | undefined): string | undefined {
  if (isUsageLimitReachedError(message)) {
    return USAGE_LIMIT_REACHED_MESSAGE;
  }
  if (isPaymentRequiredError(message)) {
    return PAYMENT_REQUIRED_MESSAGE;
  }
  return undefined;
}
